import { Initiator } from '@/models/logs.model';
import { OrderStatus } from '@/models/order.model';
import { AppraiserStepProgress, UserStepProgress } from '@/models/propertyProgress.model';
import { StepStatus } from '@/models/step.model';

export enum StepProgressStatus {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  WAITING = 'waiting_for_self-upload',
  COMPLETED = 'completed',
  PENDING = 'pending',
}

export const getAppraiserStatus = (step: AppraiserStepProgress) => {
  if (!step.order?.status && step.status === StepStatus.IN_PROGRESS) {
    return StepProgressStatus.WAITING;
  }

  return step.status;
};

export const getStepUploader = (step: UserStepProgress): Initiator | undefined => {
  if (!step.order?.status && step.status !== StepStatus.PENDING) {
    return Initiator.USER;
  }

  if (!!step.order?.status && step.order.status !== OrderStatus.NEW) {
    return Initiator.ADMIN;
  }
};
